import { render, staticRenderFns } from "./GuestsSFTP.vue?vue&type=template&id=58a8610a&scoped=true&"
import script from "./GuestsSFTP.vue?vue&type=script&lang=js&"
export * from "./GuestsSFTP.vue?vue&type=script&lang=js&"
import style0 from "./GuestsSFTP.vue?vue&type=style&index=0&id=58a8610a&prod&lang=css&"
import style1 from "./GuestsSFTP.vue?vue&type=style&index=1&id=58a8610a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a8610a",
  null
  
)

export default component.exports